import { setActiveViewTeamHealth } from "#webapp/src/state/actions/chrome-extension.actions";
import { ApolloError, useMutation } from "@apollo/client";
import { UnsyncHoldInput } from "@clockwise/schema";
import {
  UnsyncHoldDocument,
  UnsyncHoldMutation,
} from "@clockwise/web-commons/src/mutations/__generated__/UnsyncHold.generated";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";

type UseUnsyncHoldProps = {
  input: UnsyncHoldInput;
  onError?: (error: ApolloError) => void;
  onCompleted?: (data: UnsyncHoldMutation) => void;
};

type UseUnsyncHoldResult = [
  () => Promise<void>,
  { loading: boolean; error: ApolloError | undefined },
];

export function useUnsyncHold({
  input,
  onError,
  onCompleted,
}: UseUnsyncHoldProps): UseUnsyncHoldResult {
  const dispatch = useDispatch();
  const [unsyncHold, { loading, error }] = useMutation(UnsyncHoldDocument, {
    variables: { input },
    onError,
    onCompleted,
  });

  const onUnsyncHold = useCallback(async () => {
    const result = await unsyncHold();
    if (result.data?.unsyncHold?.success) {
      toast.success(
        "Your hold was successfully removed. Please allow a few moments for the update to occur.",
      );
      dispatch(setActiveViewTeamHealth());
    }
  }, [unsyncHold]);

  return [onUnsyncHold, { loading, error }];
}
